import {get} from "app/requests/preview/newsletters";
import * as Pages from "components/pages";

export default function PreviewNewslettersShow() {
  return <Pages.Public.Newsletters.Show getRecord={get} prefix="/preview" />;
}
